import React, { useState } from "react";
import Tabs from "../../components/Tabs/Tabs";

import { ReactComponent as SettingsIcon } from "../../assets/icons/settings.svg";
import { ReactComponent as BackspaceIcon } from "../../assets/icons/backspace.svg";
import { ReactComponent as DeleteIcon } from "../../assets/icons/delete.svg";
import { ReactComponent as ConsoleIcon } from "../../assets/icons/console.svg";
import { ReactComponent as PowerIcon } from "../../assets/icons/power.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/icons/arrow_down.svg";
import { ReactComponent as DesktopIcon } from "../../assets/icons/desktop.svg";
import { ReactComponent as GameIcon } from "../../assets/icons/game.svg";

import ActionListItem from "./ActionListItem";
import UserService from "../../services/UserService";
import ManualTerminal from "../../components/Manual/ManualTerminal";
import General from "./Shared/General";
import { NavLink, useLocation } from "react-router-dom";
import ActionButton from "../../components/Buttons/ActionButton";
import Modal from "../../components/Modals/ConfirmModal";
import Monitor from "./Shared/Monitor";
import Manual from "./Shared/Manual";
import Program from "./Shared/Program";
import Settings from "./Shared/Settings";
import Stream from "./Camera/Tabs/Stream";
import { useDeviceGroup } from "../../Api/newSockets.api";
import AddButton from "../../components/Buttons/AddButton";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { savePathToLocalStorage } from "../../utils/helpers";

type DeviceProp = {
  match: any;
  device: any;
};
const GroupDetails = (props: DeviceProp) => {
  savePathToLocalStorage();

  const allowedProps = { test: "General" };
  const { getDeviceGroup } = useDeviceGroup();
  const { deviceGroup } = getDeviceGroup(props.match.params.groupId);

  return deviceGroup ? (
    <div className="device-main main-content">
      <div>
        <div className="header">
          <NavLink to="/devices" className="device-actions">
            <ArrowDownIcon />
          </NavLink>
          <h3 className="title">{deviceGroup.name}</h3>
          <div className="list-item-actions main">
            {/* Implement status */}
            {/* <ActionButton icon={<PowerIcon />} className={`list-item-action ${group.status && 'online'}`}/> */}
            <ActionButton
              icon={<PowerIcon />}
              className={`list-item-action online`}
            />
            <ActionButton icon={<ConsoleIcon />} className="list-item-action" />
            <ActionButton icon={<DeleteIcon />} className="list-item-action" />
          </div>
        </div>

        <Tabs>
          {/* <General label="General" icon={<GameIcon />} deviceId= {props.id} hubId={props.hubId}/> */}
          {/* <Monitor label="Monitor" icon={<DesktopIcon />} /> */}
          {/* <Manual label="Manual" icon={<GameIcon />} deviceId= {props.id} hubId={props.hubId}/> */}
          {/* <Program label="Program" icon={<SettingsIcon/>} deviceId= {props.id}/> */}
          {/* <Settings label="Settings" icon={<SettingsIcon />} /> */}
        </Tabs>
      </div>

      <Tabs>
        {/* <General label="General" icon={<GameIcon />} deviceId= {props.id} hubId={props.hubId}/> */}
        {/* <Monitor label="Monitor" icon={<DesktopIcon />} /> */}
        {/* <Manual label="Manual" icon={<GameIcon />} deviceId= {props.id} hubId={props.hubId}/> */}
        {/* <Program label="Program" icon={<SettingsIcon/>} deviceId= {props.id}/> */}
        {/* <Settings label="Settings" icon={<SettingsIcon />} /> */}
      </Tabs>
    </div>
  ) : (
    <LoadingSpinner />
  );
};

export default GroupDetails;
